import React, { useEffect, useState } from 'react'
import DynamicTable from '../../components/DynamicTable'
import CssBaseline from '@material-ui/core/CssBaseline'
import { API } from 'aws-amplify';
import DForm from '../../components/DForm';
import ConfirmationModal from '../../components/ConfirmationModal';
import useUIState from '../../hooks/useUIstate';
import { s3put, s3remove } from '../../helpers/commonFunctions';
import { pCategoryFormToReqBody } from './ProductCategoriesController';
import { ProductCategory } from '../../interfaces/IProductCategory';
import ProductCategoryTranslationModal from '../../components/ProductCategoryTranslationModal';
import { useTranslation } from 'react-i18next';

function ProductCategoriesTable(props) {
    const { setShowLoadingModal, setToastMessage, setShowToastMessage, setToastType } = useUIState();
    const [data, setData]: [any[], any] = useState([]);
    const [showForm, setShowForm]: [boolean, any] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal]: [boolean, any] = useState(false);
    const [formValues, setFormValues]: [any, any] = useState({});
    const [activeRow, setActiveRow]: [any, any] = useState(null);
    const [formMode, setFormMode]: [string, any] = useState("");
    const [formObj, setFormObj]: [Record<string, any>[], any] = useState([]);
    const [UserConfigData, setUserConfigData]: [any, any] = useState([]);
    const [showTranslationModal, setShowTranslationModal]: [boolean, any] = useState(false);
    const [translationFormModel, setTranslationFormModel]: [any, any] = useState({});
    const [translationFormFieldsModel, setTranslationFormFieldsModel]: [any, any] = useState({});
    const [productCategoryForTranslate, setProductCategoryForTranslate]: [any, any] = useState({});
    const { t } = useTranslation();


    useEffect(() => {
        const value = localStorage.getItem("UserConfigData");
        if (typeof value === 'string') {
            setUserConfigData(JSON.parse(value));
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        renderData();
        // eslint-disable-next-line
    }, [props.data])

    async function renderData() {
        const productsRender: ProductCategory[] = [];
        props.data.forEach(p => {
            productsRender.push({
                Id: p.Id,
                Code: p.Code,
                Title: p.Title,
                Description: p.Description,
                Avatar: p.Avatar,
            })
        });
        setData(productsRender);
        setShowLoadingModal(false);
    }

    async function createOrUpdateProductCategory(reqBody: ProductCategory) {
        let path = '/ProductCategories';
        let body: ProductCategory = {
            "Code": new Date().getTime().toString(),
            "Title": reqBody.Title,
            "Description": reqBody.Description,
            "Avatar": reqBody.Avatar
        }
        if (reqBody.Id) { body.Id = reqBody.Id };
        let res;
        if (reqBody.Id) {
            res = await API.put('AE', path, { body });
        } else {
            res = await API.post('AE', path, { body });
        }
        return res;
    }

    async function countProducts() {
        let path = '/ProductCategories/CountProducts';
        let myInit = {}
        try {
            return await API.get('AE', path + "?productCategoryId=" + activeRow.original.Id, myInit);
        } catch (err) {
            console.log(err);
            return 1;
        }
    }

    async function deleteEntry() {
        let path = '/ProductCategories';
        let myInit = {}
        try {
            return await API.del('AE', path + "?productCategoryId=" + activeRow.original.Id, myInit);
        } catch (err) {
            console.log(err);
            return null;
        }
    }

    const columns = React.useMemo(
        () => [
            {
                Header: 'Id',
                accessor: 'Id',
                hide: true,
            },
            {
                Header: t('productcategoriestable.category-code'),
                accessor: 'Code',
                hide: true,
            },
            {
                Header: t('productcategoriestable.name'),
                accessor: 'Title',
            },
            {
                Header: t('productcategoriestable.description'),
                accessor: 'Description',
                hide: true,
            },
            {
                Header: t('productcategoriestable.avatar'),
                accessor: 'Avatar',
                hide: true,
            },
        ],
        []
    );

    function prepTranslation(row) {
        setShowLoadingModal(true);
        API.get("AE", `/Translations/GetProductCategoryTranslations?productCategoryId=${row.values.Id}`, { response: true })
            .then(res => {
                let data = res.data;
                let fields = [{ name: 'LanguageCode', input: false }, { name: 'Title', input: true }];
                setTranslationFormModel(data);
                setTranslationFormFieldsModel(fields);
                setProductCategoryForTranslate(row.values);
                setShowTranslationModal(true);
            })
            .catch(error => {
                console.log(error);
                setToastType("error");
                setToastMessage(t('productcategoriestable.error.getting-productcategories'));
                setShowToastMessage(true);
            })
            .finally(() => {
                setShowLoadingModal(false);
            })
    }

    async function prepForm(row) {

        const rowValues = row !== null ? row.original : null;
        const addingRow = rowValues === null;

        const _formValues = {
            Code: addingRow ? "" : rowValues.Code,
            Title: addingRow ? "" : rowValues.Title,
            Description: addingRow ? "" : rowValues.Description,
            Avatar: addingRow ? "" : rowValues.Avatar
        };

        const formObj = [
            {
                name: "Title",
                type: "text",
                label: t('productcategoriestable.name'),
                required: true,
                initialValue: addingRow ? "" : rowValues.Title
            },
            {
                name: "Description",
                type: "text",
                label: t('productcategoriestable.description'),
                checked: addingRow ? "" : rowValues.Description
            },
            {
                name: "Avatar",
                type: "file",
                label: t('generic.select'),
                objUrl: addingRow ? "" : rowValues.Avatar.trim() ? UserConfigData.Customer + '/images/product-categories/catid' + rowValues.Id + "_" + rowValues.Avatar : "",
                maxHeight: 320,
                maxWidth: 320
            },
        ];
        setFormObj(formObj);
        setActiveRow(rowValues);
        setFormMode(rowValues === null ? 'Add' : 'Edit');
        setFormValues(_formValues);
        setShowForm(true);
    }
    
    async function submit(values) {
        let validated = true;

        console.log(values);
        console.log(activeRow);

        if (!values.Avatar || values.Avatar === " ") {
            setToastType("error");
            setToastMessage(t('productcategoriestable.error.add-image'));
            setShowToastMessage(true);
            validated = false;
        }

        // check for unique code
        if (data.find(el => el.Code === values.Code)) {
            let valueExists;
            if (activeRow === null) {
                valueExists = true;
            } else {
                if (data.find(el => el.Code === values.Code).Id !== activeRow.Id) {
                    valueExists = true;
                }
            }
            if (valueExists) {
                setToastType("error");
                setToastMessage(t('productcategoriestable.error.code-exists'));
                setShowToastMessage(true);
                validated = false;
            }
        }

        /*
        resize image
        */
        //await resizeImage(values, 60);

        if (validated) {
            setShowLoadingModal(true);
            const reqBody = pCategoryFormToReqBody(activeRow, values);

            setShowForm(false);
            const res = await createOrUpdateProductCategory(reqBody);
            if (res) {
                setToastType("success");
                //setToastMessage(`ProductCategory ${activeRow === null ? "added" : "edited"} successfully!`);
                setToastMessage(
                t('productcategoriestable.edit-success', {
                    productcategory: t('productcategoriestable.productcategory'),
                    action: activeRow === null ? t('generic.added') : t('generic.edited')
                })
                );

                setShowToastMessage(true);
                props.getData();
            } else {
                setToastType("error");
                //setToastMessage(`Error ${activeRow === null ? "adding" : "editing"} ProductCategory`);
                setToastMessage(
                t('productcategoriestable.edit-fail', {
                    error: t('generic.error'),
                    action: activeRow === null ? t('generic.adding') : t('generic.editing'),
                    productcategory: t('productcategoriestable.productcategory')
                })
                );
                setShowToastMessage(true);
            }

            let putResp;
            let imageChange;

            if (activeRow) {
                if (values.Avatar !== activeRow.Avatar) {
                    imageChange = true;
                    putResp = await s3put(`${UserConfigData.Customer}/images/product-categories/catid${res.Id}_${reqBody.Avatar}`, values.Avatar);
                }
            } else {
                imageChange = true;
                putResp = await s3put(`${UserConfigData.Customer}/images/product-categories/catid${res.Id}_${reqBody.Avatar}`, values.Avatar);
            }

            if (!putResp && imageChange) {
                setToastType("error");
                setToastMessage(t('productcategoriestable.error.image-upload-failed'));
                setShowToastMessage(true);
            }

            setShowLoadingModal(false);
        }
    }

    async function submitTranslationValue(rows) {
        let path = `/Translations/AddOrUpdateProductCategoryTranslation`;
        let body = rows;
        await API.post('AE', path, { body });
        setShowTranslationModal(false);
        setToastType("success");
        setToastMessage(t('productcategoriestable.save-success'));
        setShowToastMessage(true);
    }

    function handleDeleteConfirmation(row) {
        setActiveRow(row);
        setShowConfirmationModal(true);
    }

    function showToast(type, message) {
        setToastType(type);
        setToastMessage(message);
        setShowToastMessage(true);
    }

    async function confirmDelete() {
        setShowLoadingModal(true);
        setShowConfirmationModal(false);
        const productCount = await countProducts();
        if (productCount > 0) {
            //showToast("error", 'Category still contains ${productCount} products');
            showToast("error",t('productcategoriestable.error.contains-products', { count: productCount }));            
        }
        else {
            const deleted = await deleteEntry();
            if (deleted) {
                showToast("success", t('productcategoriestable.delete-success'));
                if (activeRow.original.Avatar.trim()) {
                    const filePath = `${UserConfigData.Customer}/images/product-categories/catId${activeRow.original.Id}_${activeRow.original.Avatar}`
                    const res = await s3remove(filePath);
                    if (!res) {
                        showToast("error", t('productcategoriestable.error.image-delete-failed'));
                    }
                }
            }
            else {
                showToast("error", t('productcategoriestable.error.delete-category'));
            }
        }
        props.getData();
    }

    return (
        <div>
            <h1>{t('productcategoriestable.product-management')}</h1>
            <h2 className="mb-05">{t('productcategoriestable.product-categories')}</h2>
            <CssBaseline />
            <DynamicTable
                addRow={() => prepForm(null)}
                editRow={(row) => prepForm(row)}
                editRowTranslation={(row) => prepTranslation(row)}
                deleteRow={(row) => handleDeleteConfirmation(row)}
                columns={columns}
                data={data}
                loading={false}
                className="ProductCategories"
            />
            {
                showForm ?
                    <DForm
                        formObj={formObj}
                        formMode={formMode}
                        initialValues={formValues}
                        closeModal={() => setShowForm(false)}
                        submit={submit}
                    />
                    : null
            }
            {
                showTranslationModal ?
                    <ProductCategoryTranslationModal
                        rows={translationFormModel}
                        fields={translationFormFieldsModel}
                        productCategory={productCategoryForTranslate}
                        closeModal={() => setShowTranslationModal(false)}
                        save={submitTranslationValue}
                    />
                    : null
            }
            {showConfirmationModal ?
                <ConfirmationModal
                    message={t('productcategoriestable.question-delete-category')}
                    confirm={confirmDelete}
                    closeModal={() => setShowConfirmationModal(false)}
                />
                : null}
        </div>
    )
}

export default ProductCategoriesTable;
